export class SolutionDetail {
    image: string;
    title: string;
    template: string;
}